import { FC, useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { useHistory } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from 'hooks/store'
import useLoadingDelay from 'hooks/useLoadingDelay'
import { loadingSpinnerPortal } from 'components/atoms/LoadingSpinner'
import GoBackHeader from 'components/organisms/GoBackHeader'
import {
  setSelectedDocumentCategoryId,
  setSelectedDocumentCategory,
  setIsCourseCertificateUpload
} from 'reducers/document/documentProcessingSlice'
import CategoryDocumentList from 'components/atoms/CategoryDocumentList'
import { DocumentCategory } from 'share/domain/document'
import {
  GET_CHILD_FOLDERS_FOR_PARENT_FOLDER_QUERY,
  GetChildFoldersForParentFolderQueryResponse,
  GetChildFoldersForParentFolderQueryVariables
} from 'share/queries/documents'

import { DocsContainer } from './styles'

const DocumentsParentFolder: FC = () => {
  const [categories, setCategories] = useState<DocumentCategory[]>([])
  const documentProcessing = useAppSelector((state) => state.documentProcessing)
  const caseData = useAppSelector((state) => state.activeCase)
  const history = useHistory()
  const dispatch = useAppDispatch()

  const { data, loading, error } = useQuery<
    GetChildFoldersForParentFolderQueryResponse,
    GetChildFoldersForParentFolderQueryVariables
  >(GET_CHILD_FOLDERS_FOR_PARENT_FOLDER_QUERY, {
    variables: {
      categoryId: documentProcessing.selectedDocumentCategoryId
        ? documentProcessing.selectedDocumentCategoryId
        : 0,
      caseId: caseData.matter?.id || 0
    }
  })

  dispatch(setIsCourseCertificateUpload(false))

  useEffect(() => {
    if (
      data &&
      data?.documents.childFoldersForParentFolder.subCategories.length > 0
    ) {
      setCategories(data?.documents.childFoldersForParentFolder.subCategories)

      console.log(
        'subCategories',
        data?.documents.childFoldersForParentFolder.subCategories
      )
    }
  }, [data])

  const loadingDelay = useLoadingDelay(loading)

  if (error) {
    return <div>{error.message}</div>
  }

  return (
    <>
      <GoBackHeader
        text={documentProcessing.documentOperation + ' Documents'}
      />
      {loadingDelay && loadingSpinnerPortal()}
      <DocsContainer className='mt-4 mt-lg-5'>
        <h2 data-testid='documents-category-title'>
          {documentProcessing.selectedDocumentCategory?.name}
        </h2>
        {categories && (
          <CategoryDocumentList
            showButton
            showStatus
            documentCategories={categories}
            onClick={(subCategory) => {
              if (!subCategory) return
              dispatch(setSelectedDocumentCategoryId(subCategory.id))
              dispatch(
                setSelectedDocumentCategory(subCategory as DocumentCategory)
              )
              history.push('/dashboard/documents/subCategory')
            }}
          />
        )}
      </DocsContainer>
    </>
  )
}

export default DocumentsParentFolder
